import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReceitasBrutasAnterioresComponent } from './receitas-brutas-anteriores-listar/receitas-brutas-anteriores.component';
import { ReceitasBrutasAnterioresEditarComponent } from './receitas-brutas-anteriores-editar/receitas-brutas-anteriores-editar.component';

const routes: Routes = [
  { path: '', component: ReceitasBrutasAnterioresComponent },
  { path: 'adicionar/:id', component: ReceitasBrutasAnterioresEditarComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReceitasBrutasAnterioresRoutingModule {}
